var render = function () {
  var _vm$settings$detailLi, _vm$settings$detailLi2, _vm$settings$detailLi3, _vm$settings$detailLi4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.readerClasses
  }, [_c('v-touch', {
    on: {
      "tap": _vm.closeSidebar
    }
  }, [_c('div', {
    staticClass: "t-mask"
  })]), _c('header', {
    staticClass: "t-header",
    attrs: {
      "role": "banner"
    }
  }, [_c('div', {
    staticClass: "t-header-inner"
  }, [((_vm$settings$detailLi = _vm.settings.detailLink) !== null && _vm$settings$detailLi !== void 0 ? _vm$settings$detailLi : _vm.pubInfo.detailUrl) ? _c('a', {
    staticClass: "t-title",
    attrs: {
      "href": (_vm$settings$detailLi2 = _vm.settings.detailLink) !== null && _vm$settings$detailLi2 !== void 0 ? _vm$settings$detailLi2 : _vm.pubInfo.detailUrl
    }
  }, [_vm._v(" " + _vm._s(_vm.pubInfo.title) + " ")]) : _c('span', {
    staticClass: "t-title"
  }, [_vm._v(_vm._s(_vm.pubInfo.title))])])]), _c('nav', {
    ref: "sidebar",
    staticClass: "t-sidebar",
    style: {
      '--unzoom-sidebar': _vm.sidebarUnzoom
    },
    attrs: {
      "role": "navigation"
    }
  }, [_c('Toolbar', {
    ref: "toolbar",
    attrs: {
      "direction": "vertical"
    }
  }, [_vm.settings.homeLink ? _c('ButtonLink', {
    attrs: {
      "href": _vm.settings.homeLink,
      "icon": _vm.settings.homeIcon === 'bookshelf' ? 'icon-catalog' : 'icon-home',
      "size": "large",
      "spin": "icon-only"
    }
  }, [_vm._v(" Document Home ")]) : _vm._e(), _vm.prefs.showZoomButtons || _vm.pagingMode === 'tower' ? _c('ButtonPush', {
    attrs: {
      "icon": "icon-larger",
      "size": "large",
      "spin": "icon-only"
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_vm._v(" Zoom in ")]) : _vm._e(), _vm.prefs.showZoomButtons || _vm.pagingMode === 'tower' ? _c('ButtonPush', {
    attrs: {
      "icon": "icon-smaller",
      "size": "large",
      "spin": "icon-only"
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_vm._v(" Zoom out ")]) : _vm._e(), _c('ButtonPush', {
    attrs: {
      "aria-controls": _vm.$id('sidebar-search'),
      "aria-expanded": _vm.sidebarOpen('search') ? 'true' : 'false',
      "aria-haspopup": "true",
      "icon": "icon-search",
      "size": "large",
      "spin": "icon-only"
    },
    on: {
      "click": function click($event) {
        return _vm.toggleSidebar('search');
      }
    }
  }, [_vm._v(" Search ")]), _c('Panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.sidebarOpen('search'),
      expression: "sidebarOpen('search')"
    }],
    staticClass: "t-sidebar-search",
    attrs: {
      "closer": "searchToggle",
      "id": _vm.$id('sidebar-search'),
      "role": "region"
    },
    on: {
      "close": _vm.closeSidebar
    }
  }, [_c('div', {
    staticClass: "t-bounds"
  }, [_c('div', {
    staticClass: "t-panel-section"
  }, [_c('div', {
    staticClass: "t-panel-heading"
  }, [_vm.settings.backToSearch ? _c('a', {
    attrs: {
      "href": _vm.settings.backToSearch
    }
  }, [_vm._v(" Return to search in progress ")]) : _vm.settings.advancedSearchLink ? _c('a', {
    attrs: {
      "href": _vm.settings.advancedSearchLink
    }
  }, [_vm._v(" Use advanced search ")]) : _c('div', [_vm._v("Search")])])]), _c('SearchPanel')], 1)]), _c('ButtonPush', {
    attrs: {
      "aria-controls": _vm.$id('sidebar-toc'),
      "aria-expanded": _vm.sidebarOpen('toc') ? 'true' : 'false',
      "aria-haspopup": "true",
      "icon": "icon-toc",
      "size": "large",
      "spin": "icon-only"
    },
    on: {
      "click": function click($event) {
        return _vm.toggleSidebar('toc');
      }
    }
  }, [_vm._v(" Table of Contents ")]), _c('Panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.sidebarOpen('toc'),
      expression: "sidebarOpen('toc')"
    }],
    staticClass: "t-sidebar-toc",
    attrs: {
      "closer": "tocToggle",
      "id": _vm.$id('sidebar-toc'),
      "role": "region"
    },
    on: {
      "close": _vm.closeSidebar
    }
  }, [_c('div', {
    staticClass: "t-bounds"
  }, [_vm.pubInfo.detailUrl ? _c('div', {
    staticClass: "t-panel-section"
  }, [_c('div', {
    staticClass: "t-panel-heading"
  }, [((_vm$settings$detailLi3 = _vm.settings.detailLink) !== null && _vm$settings$detailLi3 !== void 0 ? _vm$settings$detailLi3 : _vm.pubInfo.detailUrl) ? _c('a', {
    attrs: {
      "href": (_vm$settings$detailLi4 = _vm.settings.detailLink) !== null && _vm$settings$detailLi4 !== void 0 ? _vm$settings$detailLi4 : _vm.pubInfo.detailUrl
    }
  }, [_vm._v(" " + _vm._s(_vm.pubInfo.title) + " ")]) : _c('span', [_vm._v(_vm._s(_vm.pubInfo.title))])])]) : _vm._e(), _c('div', {
    staticClass: "t-panel-subheading"
  }, [_vm._v("Table of Contents")]), _c('Toc', {
    attrs: {
      "model": _vm.contents
    }
  })], 1)]), _c('ButtonPush', {
    attrs: {
      "aria-controls": _vm.$id('sidebar-attachments'),
      "aria-expanded": _vm.sidebarOpen('attachments') ? 'true' : 'false',
      "aria-haspopup": "true",
      "icon": _vm.settings.attachmentsIcon === 'arrow' ? 'icon-link-external' : 'icon-attach',
      "size": "large",
      "spin": "icon-only"
    },
    on: {
      "click": function click($event) {
        return _vm.toggleSidebar('attachments');
      }
    }
  }, [_vm._v(" Attachments ")]), _c('Panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.sidebarOpen('attachments'),
      expression: "sidebarOpen('attachments')"
    }],
    staticClass: "t-sidebar-attachments",
    attrs: {
      "closer": "attachmentsToggle",
      "id": _vm.$id('sidebar-attachments'),
      "role": "region"
    },
    on: {
      "close": _vm.closeSidebar
    }
  }, [_c('AttachmentsPanel', _vm._b({
    attrs: {
      "visible": _vm.sidebarOpen('attachments')
    }
  }, 'AttachmentsPanel', {
    page: _vm.page,
    pubInfo: _vm.pubInfo
  }, false))], 1), _c('ButtonPush', {
    attrs: {
      "aria-controls": _vm.$id('sidebar-settings'),
      "aria-expanded": _vm.sidebarOpen('settings') ? 'true' : 'false',
      "aria-haspopup": "true",
      "icon": "icon-settings",
      "size": "large",
      "spin": "icon-only"
    },
    on: {
      "click": function click($event) {
        return _vm.toggleSidebar('settings');
      }
    }
  }, [_vm._v(" Preferences ")]), _c('Panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.sidebarOpen('settings'),
      expression: "sidebarOpen('settings')"
    }],
    staticClass: "t-sidebar-settings",
    attrs: {
      "closer": "settingsToggle",
      "id": _vm.$id('sidebar-settings'),
      "role": "region"
    },
    on: {
      "close": _vm.closeSidebar
    }
  }, [_c('div', {
    staticClass: "t-bounds"
  }, [_c('div', {
    staticClass: "t-panel-section"
  }, [_c('div', {
    staticClass: "t-panel-subheading"
  }, [_vm._v("Preferences")]), _vm.pagingMode === 'strip' ? _c('p', [_c('ButtonToggle', {
    attrs: {
      "size": "large",
      "spin": "switch"
    },
    model: {
      value: _vm.prefs.showZoomButtons,
      callback: function callback($$v) {
        _vm.$set(_vm.prefs, "showZoomButtons", $$v);
      },
      expression: "prefs.showZoomButtons"
    }
  }, [_vm._v(" Show Zoom Buttons ")])], 1) : _vm._e(), _vm.pagingMode === 'strip' && _vm.isMobile ? _c('p', [_c('ButtonToggle', {
    attrs: {
      "size": "large",
      "spin": "switch"
    },
    model: {
      value: _vm.prefs.tapToChangePages,
      callback: function callback($$v) {
        _vm.$set(_vm.prefs, "tapToChangePages", $$v);
      },
      expression: "prefs.tapToChangePages"
    }
  }, [_vm._v(" Tap To Change Pages ")])], 1) : _vm._e(), _c('p', [_c('IconLink', {
    staticClass: "t-view-link t-bold-link",
    attrs: {
      "icon": "icon-arrows-ccw",
      "size": "medium"
    },
    on: {
      "click": _vm.prefs.reset
    }
  }, [_vm._v(" Restore Defaults ")])], 1)]), _vm.settings.feedbackSurvey ? _c('div', {
    staticClass: "t-panel-section"
  }, [_c('div', {
    staticClass: "t-panel-subheading"
  }, [_vm._v("Feedback")]), _c('p', [_vm._v(" Help us improve your reading experience. "), _c('a', {
    attrs: {
      "href": _vm.feedbackLink,
      "target": "_blank"
    }
  }, [_vm._v(" Take our 3-minute survey. ")])])]) : _vm._e()])])], 1)], 1), _c('main', {
    staticClass: "t-main",
    attrs: {
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "t-viewer"
  }, [_vm.pagingMode === 'strip' ? _c('Strip', _vm._b({
    ref: "viewer"
  }, 'Strip', {
    pageNum: _vm.pageNum,
    pages: _vm.pages,
    searchTerms: _vm.searchTerms,
    viewerHeight: _vm.viewerHeight,
    viewerWidth: _vm.viewerWidth
  }, false)) : _vm._e(), _vm.pagingMode === 'tower' ? _c('Tower', _vm._b({
    ref: "viewer"
  }, 'Tower', {
    firstPage: _vm.firstPage,
    lastPage: _vm.lastPage,
    pageNum: _vm.pageNum,
    pages: _vm.pages
  }, false)) : _vm._e(), _vm.pagingMode === 'strip' && _vm.prefs.tapToChangePages ? [_c('v-touch', {
    staticClass: "t-prev-tap-target",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "tap": _vm.tapPrevious
    }
  }), _c('v-touch', {
    staticClass: "t-next-tap-target",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "tap": _vm.tapNext
    }
  })] : _vm._e()], 2)]), _c('Footer', {
    attrs: {
      "canPageNext": _vm.pagingMode === 'strip' && _vm.pageNum < _vm.lastPage,
      "canPagePrevious": _vm.pagingMode === 'strip' && _vm.pageNum > _vm.firstPage,
      "lastLogicalPage": _vm.logicalPages[_vm.lastPage - 1],
      "logicalPage": _vm.logicalPages[_vm.pageNum - 1]
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }